import { Button, IconButton, TextField } from '@mui/material';
import { useSigners } from '../../../hooks/useSigners';
import { DraftContext } from '../../../context/DraftContext';
import { useContext } from 'react';
import { DeleteOutlineRounded } from '@mui/icons-material';

import PropTypes from 'prop-types';

export const SignersForm = () => {
  const {setListFieldsColors} = useContext(DraftContext);

  const {signers, 
    handleAddSigner, 
    handleEditSigner, 
    handleRemoveSigner,
    handleBlurField
  } = useSigners(setListFieldsColors);

  return (
    <div className='form-signers md-text'>
      <table className='grey-text'>
        <thead style={{alignItems:'start'}}>
          <tr>
            <th>Correo *</th>
            <th>Nombre</th>
          </tr>
        </thead>
        <SignersList 
          signers = {signers} 
          handleEditSigner = {handleEditSigner} 
          handleRemoveSigner = {handleRemoveSigner}
          blurField = {handleBlurField}
          />
      </table>

      <Button onClick={handleAddSigner}>+ Agregar firmante</Button>
    </div>
  )
}

const SignersList = ({signers, handleEditSigner, handleRemoveSigner, blurField}) => {
  return (
    <tbody>
      {
        Object.keys(signers).map((signerId) => (
          <Signer 
              key = {signerId} 
              signer = {signers[signerId]} 
              handleEditSigner={handleEditSigner}
              handleRemoveSigner = {handleRemoveSigner}
              blurField = {blurField}
              />
        ))
      }
    </tbody>
  );
};

const Signer = ({ signer, handleEditSigner, handleRemoveSigner }) => {
  return (
    <tr>
      <td style={{width: '55%', paddingRight: '10px'}}>
        <TextField
          required
          type="email"
          name="email"
          margin="normal"
          fullWidth
          color="secondary"
          placeholder="Correo electrónico"
          defaultValue={signer.email}
          onBlur={({target}) => handleEditSigner(signer.id, target)}
        />
      </td>
      <td>
        <TextField
          name="name"
          fullWidth
          margin="normal"
          color="secondary"
          placeholder="Nombre"
          defaultValue={signer.name}
          onBlur={({target}) => handleEditSigner(signer.id, target)}
        />
      </td>
      <td>
        <IconButton onClick={()=> handleRemoveSigner(signer.id)}>
          <DeleteOutlineRounded />
        </IconButton>
      </td>
    </tr>
  );
};

SignersList.propTypes = {
  signers: PropTypes.object.isRequired,
  handleEditSigner: PropTypes.func.isRequired,
  handleRemoveSigner: PropTypes.func.isRequired,
  blurField: PropTypes.func.isRequired
};

Signer.propTypes = {
  signer: PropTypes.object.isRequired,
  handleEditSigner: PropTypes.func.isRequired,
  handleRemoveSigner: PropTypes.func.isRequired
};